export const stringifyQueueItem = (item: unknown) => JSON.stringify(item);
